import { shade } from 'polished';
import { animated } from 'react-spring';
import styled, { keyframes, css } from 'styled-components';
import { _ButtonProps, _DivProps } from 'styles/base';

interface AnimatedSpanProps extends _DivProps{
  $delay?: number;
  $duration?: number;
}

const appearFromLeft = keyframes`
  from{
    opacity: 0;
    transform: translateX(-150px);

  } to {
    opacity: 1;
    transform: translateX(0px);


  }
`;

export const Menu = styled.div<_DivProps>`
  display: flex;
  flex-direction: column;
  margin-top: 25px;
  div + div {
    margin-top: 15px;
  }
`;

export const AnimatedDiv = styled.div<AnimatedSpanProps>`
  opacity: 0;
  transform: translateX(-150px);

  animation: ${appearFromLeft} ${({$duration}) => $duration || 1}s ease forwards;
  transition: all 0.5s;

  a,
  button {
    background: #fff;
    border-radius: 5px;
    border: 2px solid #efefef;
    padding: 5px 15px 5px 10px;
    box-shadow: 2px 5px 10px 0px rgba(0, 0, 0, 0.5);

    width: 100%;
    display: flex;
    align-items: center;

    text-decoration: none;

    transition: all 0.5s;
    svg {
      margin-right: 15px;
      color: #363636;
      transition: all 0.5s;
    }

    h3 {
      font-size: 18.72px;
      color: #767676;
      transition: all 0.5s;

      strong {
        color: ${shade(0.25, '#767676')};
        transition: all 0.5s;
      }
    }
  }

  ${({$delay}) =>
    $delay &&
    css`
      animation-delay: ${$delay}s;
    `}

  &:hover {
    a,
    button {
      transform: translateX(10px);
      box-shadow: 2px 5px 10px 3px rgba(0, 0, 0, 0.5);
      svg {
        color: #767676;
      }
      h3 {
        color: #332e2e;
        strong {
          color: ${shade(0.25, '#8a0002')};
        }
      }
    }
  }
`;

export const ButtonsContainer = styled(animated.div)<_DivProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1px 3px;
`;

export const ButtonProceed = styled(animated.button)<_ButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #00802b;
  color: #efefef;
  padding: 2px 7px;

  border: 2px solid transparent;
  border-radius: 5px;

  font-size: 16px;
  font-family: 'Roboto Slab', serif;
  font-weight: 700;

  /* box-shadow: 2px 5px 10px 3px rgba(0, 0, 0, 0.5); */
  transition: background-color 0.35s ease, color 0.35s ease;

  &:hover {
    background-color: ${shade(0.2, '#00802b')};
    color: #fff;
  }
`;

export const ButtonCancel = styled(ButtonProceed)`
  background: #8a0002;

  &:hover {
    background-color: ${shade(0.2, '#8a0002')};
  }
`;
